import './TabNavigation.css';

export default function TabNavigation({ activeTab, onTabChange }) {
  const tabs = [
    { id: 'phone', label: '📞 Phone Controls' },
    { id: 'call-search', label: '🔍 Call Search' },
    { id: 'errors', label: '⚠️ Errors' },
    { id: 'voicemail', label: '💬 Voice Templates' },
    { id: 'ivr-questions', label: '❓ IVR Questions' },
    { id: 'ivr-flow', label: '🔀 IVR Flow' },
  ];

  return (
    <nav className="tab-navigation">
      <div className="nav-header">
        <h2>Phoenix</h2>
      </div>
      <div className="nav-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={tab.label}
          >
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
